import React, { useState } from 'react';
import {FormulasMode} from "@taskpane/utils";
import FormulasModeClass from "../../features/formulasModeClass";
import {Toggle} from "@fluentui/react";
import {useTranslation} from "react-i18next";

export const WorkToolsPage: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [displayFormulas, setDisplayFormulas] = useState<boolean>();

  async function onDisplayFormulasClick(event, checked) {
    setDisplayFormulas(checked);
    const formulasMode = checked ? FormulasMode.Formulas : FormulasMode.Amount;
    const cancellationToken = {};
    await Excel.run(async (context) => {
      await new FormulasModeClass().changeFormulasMode(
        formulasMode,
        (max, currentSheetIdentifier1) => {},
        (current) => {},
        (stoppedByUser) => {},
        cancellationToken,
        context,
      );
    });
  }

  return (
    <div className="pt-4">
      <div className="mt-1 mb-2 ms-fontWeight-bold">
        <span>{t("workToolsPage")}</span>
      </div>
      <Toggle label={t("displayFormulas")} checked={displayFormulas} onChange={onDisplayFormulasClick}></Toggle>
    </div>);

}

